import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { EnvToken } from '@app/core/env.tokens';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-insurance-usp',
  templateUrl: './insuranceUsp.component.html',
  styleUrls: ['./insuranceUsp.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgOptimizedImage, TranslatePipe, MatIconModule],
})
export class InsuranceUspComponent implements OnInit {
  protected readonly env = inject(EnvToken);

  defaultImage = '/assets/svg/logo.svg';
  insuranceSymbol = `${this.env.cloudFrontImgUrl}/private/compressed/lp/Group+161-min.webp`;
  constructor(
    private dialog: MatDialog,
    private router: Router,
  ) {}

  goToInsurancePage() {
    return this.router.navigate(['/skadegodtgoerelse']);
  }

  ngOnInit() {
    // const elem = this.document.getElementById('graphic_container_id');
    // elem.style.backgroundImage = `url('${this.cloudFront.transform('https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/Blob+purple+blue.svg')} ')`;
  }
}
